import { css } from 'styled-components'

export const typoHeadingXl = css`
  font-size: 2.25rem;
  line-height: 1;
  font-weight: 900;

  @media (max-width: 480px) {
    font-size: 2.8rem;
  }
`

export const typoHeadingL = css`
  font-size: 1.875rem;
  line-height: 1;
  font-weight: 900;

  @media (max-width: 480px) {
    font-size: 2.5rem;
  }
`

export const typoHeading1 = css`
  font-size: 1.875rem;
  line-height: 1;
  font-weight: 900;

  @media (max-width: 480px) {
    font-size: 2.3rem;
  }
`

export const typoHeading2 = css`
  font-size: 1.25rem;
  line-height: 1.15;
  font-weight: 900;

  @media (max-width: 480px) {
    font-size: 1.8rem;
  }
`

export const typoHeading3 = css`
  font-size: 1.125rem;
  line-height: 1.2;
  font-weight: 700;

  @media (max-width: 480px) {
    font-size: 1.5rem;
  }
`

export const typoHeading4 = css`
  font-size: 1rem;
  line-height: 1.2;
  font-weight: 700;
`

export const typoHeading5 = css`
  font-size: 0.875rem
  line-height: 1.2;
  font-weight: 700;
`

export const typoHeading6 = css`
  font-size: 0.9rem;
  line-height: 1.2;
  font-weight: 700;
`

export const typoParagraphIntro = css`
  font-size: 1rem;
  line-height: 1.5;
  font-weight: 400;
`

export const typoParagraph = css`
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 400;
`

export const typoParagraphS = css`
  font-size: 0.9rem;
  line-height: 1.5;
  font-weight: 400;
`

export const typoCode = css`
  font-size: 0.85rem;
  line-height: 1.5;
  font-weight: 400;
  font-family: 'Source Code Pro';
`

export const typoBlockquote = css`
  font-style: italic;
`

export const typoLabel = css`
  font-size: 0.8rem;
  line-height: 0.88rem;
  font-weight: 600;
`
